import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { majorScale, Heading, Text, defaultTheme } from 'evergreen-v4'

class NavigationBarTitleHeading extends PureComponent {
  render() {
    return (
      <Heading
        marginBottom={0}
        display="inline-flex"
        alignItems="center"
        {...this.props}
      />
    )
  }
}

export default class NavigationBarTitle extends PureComponent {
  static propTypes = {
    /**
     * The contents of the title.
     */
    children: PropTypes.node,

    /**
     * Parent of the title, rendered before a triangle icon.
     * This often needs to be a link, passing a node will not wrap
     * the parent in a Heading component.
     */
    parent: PropTypes.node
  }

  render() {
    const { children, parent, ...props } = this.props
    return (
      <React.Fragment>
        {parent && (
          <React.Fragment>
            {typeof parent === 'string' ? (
              <NavigationBarTitleHeading>{parent}</NavigationBarTitleHeading>
            ) : (
              parent
            )}
            <Text
              size={500}
              fontWeight={500}
              color={defaultTheme.scales.neutral.N10}
              opacity={0.4}
              marginX={majorScale(1)}
            >
              /
            </Text>
          </React.Fragment>
        )}
        <NavigationBarTitleHeading {...props}>
          {children}
        </NavigationBarTitleHeading>
      </React.Fragment>
    )
  }
}
